import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../../../ui/gzDataTable/types';

export enum ColumnKeys {
  NAME = 'name',
  DESCRIPTION = 'description',
  ENDPOINTS_COUNT = 'endpointsCount',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.NAME,
      header: translateFn('Name'),
      columnType: IColumnType.TEXT,
    },
    {
      key: ColumnKeys.DESCRIPTION,
      header: translateFn('Description'),
      columnType: IColumnType.TEXT,
    },
    {
      key: ColumnKeys.ENDPOINTS_COUNT,
      header: translateFn('Targeted endpoints'),
      columnType: IColumnType.TEXT,
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}
